import { IconLocationOn } from "../icon/variants/IconLocationOn.js";
import { Flex, Stack } from "../mantine-passthroughs/index.js";
import { Anchor } from "../anchor/Anchor.js";
import { Body1 } from "../typography/Body1.js";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/address/Address.tsx
const getMapUrl = (address) => {
	const url = new URL("https://maps.google.com/");
	url.searchParams.set("q", `${address.line1}, ${address.city}, ${address.state} ${address.zipCode}`);
	return url.toString();
};
const AddressBody = ({ inline, parts }) => {
	if (inline) return /* @__PURE__ */ jsx(Body1, { children: parts.join(", ") });
	return /* @__PURE__ */ jsx(Stack, {
		gap: "xxxs",
		children: parts.map((part) => /* @__PURE__ */ jsx(Body1, { children: part }, part))
	});
};
const Address = ({ actionable = true, address, showIcon = true, inline = true, "data-testid": testId }) => {
	const parts = [
		address.line1,
		address.line2,
		`${address.city}, ${address.state} ${address.zipCode}`
	].filter((str) => str?.length);
	const iconColor = actionable ? "primary" : "secondary";
	return /* @__PURE__ */ jsx(Anchor, {
		target: "_blank",
		href: actionable ? getMapUrl(address) : void 0,
		textDecoration: "none",
		"data-testid": testId,
		children: /* @__PURE__ */ jsxs(Flex, {
			align: "center",
			gap: "xxs",
			children: [showIcon && /* @__PURE__ */ jsx(IconLocationOn, { color: iconColor }), /* @__PURE__ */ jsx(AddressBody, {
				inline,
				parts
			})]
		})
	});
};

//#endregion
export { Address };